import { Component, OnInit, Inject,OnDestroy,ViewEncapsulation,ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog} from '@angular/material';
import { MediaChange, MediaObserver } from '@angular/flex-layout';
import { Subscription, Subject } from 'rxjs';
import { Validators, FormGroup, FormControl } from '@angular/forms';
import {appsettings, enumFileNamelength,enumUIFeatureView, enumUIAction, enumUIView} from '../../../app-settings';
import { ResidentForCreationResponse, ResidentMedHistory, UpdateResidentMedHistory, ShowEMRFileReport, ResidentByID, getResidentbyid, ReportById, ReportbyName, checkEmrFileData } from '../resident';
import { ResidentService } from '../resident.service';
import { RollbarService } from '../../../rollbar';
import * as Rollbar from 'rollbar';
import { HostListener } from "@angular/core";
import { SessionCheck, generateAlertMessage,AuthFailedMessage,getFeatureNeedtoShow } from '../../../app-general';
import {Router} from '@angular/router';
import * as moment from 'moment';
import { Http } from '@angular/http';
import { takeUntil } from 'rxjs/operators';
import { ConfirmMessageComponent } from '../../../confirm-message/confirm-message.component';
import { format } from 'url';

const URL = appsettings.URLinfo+'uploadEMRFile';

const deleteURL = appsettings.URLinfo+'deleteFile';

@Component({
  selector: 'app-medical-history',
  templateUrl: './medical-history.component.html',
  providers: [ ResidentService ],
  encapsulation: ViewEncapsulation.None,
  styleUrls: ['./medical-history.component.scss']
})
export class MedicalHistoryComponent implements OnInit,OnDestroy {

  watcher: Subscription;
  columns = 3;
  textcolumns = 2;
  uploadfilename = "";
  resmedfileUrl = "";
  medEMRfilename = "";
  addEMRFileName = "";
  keycode = 13;
  meddate;
  dataSource;

  dataSource_Exist=[];
  dataSource_ExistLength=0;
  EMRdataSource;
  btnvalue;
  clkaddbutton = 0;
  medhistoryResidentid;
  medhistoryid;
  medhistorynotes;
  medhistoryallergies;
  medhistorycontname;
  medhistorycontnumber;
  medhistoryemail;
  medhistoryEMR;
  medhistoryaddtype;
  updateflag = 0;
  uploademrfilevalue = 0;
  selectedaddmad = 0;
  medproceduredate = "";
  medsource = "";
  medsavebutton;
  medEMRfilesave : boolean = true; 
  medHistoryaddbool : boolean = true; 
  Residentbyid: getResidentbyid[];
  uploadfilepath: any[] = [];
  displayedColumns: string[] = ['FileName', 'ProcedureDate', 'Source', 'UploadDate'];
  EMRreportdisplayedColumns: string[] = ['FileName', 'ProcedureDate', 'Source', 'UploadDate', 'EMR', 'Delete'];
  public medicalhistoryaddForm : FormGroup;
  startDate;
  medrowHeight = "72px";
  screenWidth;
  checkemrflag = 0;
  SiteId = "1";
  uploadFileflag = 0;
  bResidentAddEdit=false;
  
  private _onDestroy: Subject<void> = new Subject<void>();
  constructor(public http : Http,private router: Router,mediaObserver: MediaObserver,public thisDialogRef: MatDialogRef<MedicalHistoryComponent>,public dialog: MatDialog,
    @Inject(RollbarService) private rollbar: Rollbar, @Inject(MAT_DIALOG_DATA) public data: any,private residentService: ResidentService) {    
    this.btnvalue = "Choose File";
   
    if (getFeatureNeedtoShow(enumUIFeatureView.Resident, enumUIAction.Resident_AddEditDelete) == enumUIView.Show) {
      this.bResidentAddEdit=true;
      }

    if(data.AddType != 1)
    {
      this.updateflag = 1;
      this.medhistoryResidentid = data[0].ResidentId;
      this.medhistoryid = data[0].MedicalHistoryId;
      this.medhistorynotes = data[0].Notes;
      this.medhistoryallergies = data[0].Allergies;
      this.medhistorycontname = data[0].EmergContactName;
      this.medhistorycontnumber = data[0].EmergContactNo;
      this.medhistoryemail = data[0].EmergContactEmail;
      this.medEMRfilename = ""; 
      this.addEMRFileName = "";     
      this.getEMRReport(this.medhistoryResidentid);
    }
    else
    {
      this.updateflag = 0;
      this.medhistoryaddtype = data.AddType;
      this.medhistoryResidentid = data.ResidentId;
      this.medhistoryid = "";
      this.medhistorynotes = "";
      this.medhistoryallergies = "";
      this.medhistorycontname = "";
      this.medhistorycontnumber = "";
      this.medhistoryemail = "";
      this.medEMRfilename = "";
      this.addEMRFileName = "";
    }
    
    this.watcher = mediaObserver.media$.subscribe((change: MediaChange) => {
      if (change) {      
        if (change.mqAlias == 'xs') {
          this.columns = 2;       
          this.setupTableforXtrasmallerwidth();                         
        } 
        else if (change.mqAlias == 'sm') {
          this.columns = 3;   
          this.setupTableforsmallerwidth();                     
        }  
        else if (change.mqAlias == 'md') {
          this.columns = 3;  
          this.setupFullTable();                    
        }               
       else
       {
         this.columns = 3; 
         this.setupFullTable();      
        
       }
      }
    
    });
   }

setupTableforXtrasmallerwidth() {
  this.EMRreportdisplayedColumns = ['FileName', 'ProcedureDate', 'Source'];
    
};

setupTableforsmallerwidth() {
  this.EMRreportdisplayedColumns = ['FileName', 'ProcedureDate', 'Source', 'UploadDate'];
   
};

setupFullTable() {
    this.EMRreportdisplayedColumns = ['FileName', 'ProcedureDate', 'Source', 'UploadDate', 'EMR', 'Delete'];
    
};
@ViewChild('clkimageInput') clkimageInput: any;
public onChangeEMR(fileList: FileList)
{  
    if(fileList.length == 0)
    {
      this.clkaddbutton = 0;
    }
    var file = fileList[0];
    if(file.name.length > enumFileNamelength.length )
    {
      generateAlertMessage(this.dialog, "File name cannot exceed 128 characters in length");
      this.clkimageInput.nativeElement.value = '';         
      return;          
    }
    let itemType = file.name.substring(file.name.lastIndexOf('.')+1, file.name.length) || file.name;
    let fileTypesAllowed = ["pdf"];   
    if (!fileTypesAllowed.includes(itemType.toLowerCase())) 
    {  
      generateAlertMessage(this.dialog, "The file format is not supported, Please upload Resident EMR as pdf file"); 
      this.clkimageInput.nativeElement.value = '';        
      return;          
    }                
    pFileReader(fileList[0],this.dialog).then(data => {      
      if( data == 1)
        this.uploadfiletoPath(data,fileList[0]); 
        this.clkimageInput.nativeElement.value = ''; 
    })
  let self;
  function pFileReader(file,_dialog : MatDialog){
    var checkvalidIMG = 0;
    return new Promise((resolve, reject) => {
      let fileReader: FileReader = new FileReader();
      fileReader.onload  = function(x) {
        self = fileReader.result; 
        self = self.split('\n');                                                 
        if((self[0].includes('%PDF')))
        {         
            checkvalidIMG = 1;              
            resolve(checkvalidIMG);                                                                              
        }          
        else
        {
          checkvalidIMG = 2;
          generateAlertMessage(_dialog, "The Resident EMR file which you tried to upload is not valid file"); 
          resolve(checkvalidIMG);           
        }        
      };           
      
      fileReader.readAsText(file);
    });
  }

}

uploadfiletoPath(data,file)
{
      var formData = new FormData(); 
      formData.append('file', file, file.name);    
      this.http.post(URL, formData).pipe(takeUntil(this._onDestroy)).subscribe((res) => {      
        let resSTR = JSON.stringify(res);
        let resJSON = JSON.parse(resSTR);          
        this.medEMRfilename = resJSON._body;
        this.resmedfileUrl = appsettings.RESIDENT_MEDICALHISTORY + resJSON._body;      
        this.uploademrfilevalue = 1;      
        this.addEMRFileName = resJSON._body;
          this.addEMRReport(this.medEMRfilename); 
      });
}


   
  ngOnInit() {  
    this.onResize();  
    if(this.updateflag == 0)
        this.medsavebutton = true;   

    this.startDate = "1900-01-01T12:00:00.000Z";

    this.medicalhistoryaddForm = new FormGroup({
      notes: new FormControl(''),     
      allergies:new FormControl(''),
      emrcontactname: new FormControl('',[Validators.required, Validators.maxLength(30), Validators.pattern(appsettings.Name_Pattern)]),
      emrcontactnumber: new FormControl('',[Validators.required,  Validators.maxLength(12), Validators.minLength(11), Validators.pattern(appsettings.Number_Pattern)]),     
      emrcontactemail: new FormControl('',[Validators.required, Validators.maxLength(60), Validators.email,Validators.pattern(appsettings.Email_Pattern)]),
      emportemr: new FormControl(''),
      ProcedureDate : new FormControl('')      
    }); 

    this.medicalhistoryaddForm.get('emportemr').disable();
  }

  handleInput(event) 
  {
    try
    {
      var n = event.target.value.lastIndexOf(" ");
      var l = event.target.value.length;
      var changedValue = event.target.value;
      if (event.which == 32 && changedValue.trim().length == 0) {
        changedValue = changedValue.trim();
      }
      else if (event.which == 32) {
        if (n + 1 == l) {
          changedValue = changedValue.trim() + " ";
        }
        else {
          changedValue = changedValue.trim();
        }
      }
      Object.keys(this.medicalhistoryaddForm.controls).forEach(field => { // {1}
        const control = this.medicalhistoryaddForm.get(field); // {2}
        if (field == document.getElementById(event.target.id).getAttribute("formControlName")) {
          control.setValue(changedValue);
          control.markAsTouched({ onlySelf: true });       // {3}
        }
      });
    }
    catch(err) 
    {
      throw new Error('add-staff.component.ts' + ' - handleInput() - ' + err.message);
    }
  }
  @HostListener('window:resize', ['$event'])
  onResize() {        
    const isIEOrEdge = /msie\s|trident\/|edge\//i.test(window.navigator.userAgent)    
     this.screenWidth = window.innerWidth;               
     if(isIEOrEdge == true)
     {          
        this.columns = 3;   
       this.medrowHeight = "73px";       
     }  
        
     if(isIEOrEdge == false && this.screenWidth < 520)
     {
       this.columns = 2; 
       this.medrowHeight = "87px";
     }     
     else if(isIEOrEdge == true && this.screenWidth < 520)
     {
       this.columns = 2; 
       this.medrowHeight = "90px";
     }  
     else if(isIEOrEdge == false)
     {
       this.columns = 3;
       this.medrowHeight = "72px";
     }
  }
  public checkEMRFile = () => {  
   
    if(!SessionCheck(this.router))
    {
        return;
    } 
   
    if(this.checkemrflag == 1 && this.updateflag == 0)
    {            
      var ConfirmMessageData = {
        ConfirmMessage: "Are you sure you want to discard the changes?"
      }     
      let dialogRef = this.dialog.open(ConfirmMessageComponent, {
        disableClose: true,
        width: 'auto',
        height: 'auto',
        panelClass: 'myapp-no-padding-dialog',
        autoFocus: false,
        data: ConfirmMessageData
      });
      
      dialogRef.afterClosed().subscribe(result => {        
        if(result == "Yes")
        {               
          let checkEMRfiledata : checkEmrFileData = 
          {
            siteId:this.SiteId, 
            authKey: localStorage.getItem("Authkey"),
            residentId:parseInt(this.medhistoryResidentid)
          }  
          this.residentService.checkEMRFile(checkEMRfiledata).pipe(takeUntil(this._onDestroy))
          .subscribe((apiresponse : any[])=>{              
            if(apiresponse)
            {                 
              this.thisDialogRef.close('Cancel');            
            }              
          });              
        }
        else
        {
          return false;
        }
      });
    }
    else
    {
      this.thisDialogRef.close('Cancel');
    }
  }

  public hasError = (controlName: string, errorName: string) =>{
    return this.medicalhistoryaddForm.controls[controlName].hasError(errorName);
  }

  public newMedHistoryAdd = (resMedicalFormValue) => {       
    try
    {      
      if(!SessionCheck(this.router))
      {
        this.thisDialogRef.close('Cancel');
          return;
      }
      (document.activeElement as HTMLTextAreaElement).blur();
      if(this.clkaddbutton == 0 || (this.clkaddbutton == 1 && this.medEMRfilename == ""))
      {       
          if (this.medicalhistoryaddForm.valid && this.medHistoryaddbool) {  
            this.medHistoryaddbool = false;        
            this.updateMedicalHistory(resMedicalFormValue);   
        }
      } 
      
    }
    catch (err) {
      throw new Error('medical-history.component.ts' + ' - newMedHistoryAdd() - ' + err.message);
    }
         
  }

  private updateMedicalHistory = (residentFormValue) => {      
  try
  {
    var empotemr="";
    if (residentFormValue.empotemr !=undefined)
    {
      empotemr=residentFormValue.emportemr.toString();
    } 
    if(this.updateflag == 0)
    {    

          var isaddvalue = 0;
            if(this.medhistoryaddtype != 1)
              isaddvalue = 0;
            else
              isaddvalue = 1;
        let residentmedhistory: ResidentMedHistory = {
          siteId: this.SiteId, 
          authKey: localStorage.getItem("Authkey"),
          notes : residentFormValue.notes.replace(/\s+/g, ' ').trim(),    
          allergies:residentFormValue.allergies.replace(/\s+/g, ' ').trim(),
          emergContactName:residentFormValue.emrcontactname.replace(/\s+/g, ' ').trim(),
          emergContactNo:residentFormValue.emrcontactnumber.toString(),
          emergContactEmail:residentFormValue.emrcontactemail.toString(),
          emrReportStatus:empotemr,
          residentId:parseInt(this.medhistoryResidentid),
        }     
          this.residentService.addMedicalHistory(residentmedhistory).pipe(takeUntil(this._onDestroy))
          .subscribe((apiresponse : ResidentForCreationResponse[])=>{       
          if(apiresponse["apiReturn"] == "Success")
          { 
            this.medHistoryaddbool = false;
            generateAlertMessage(this.dialog, 'Medical history added successfully.');                   
          }     
          else if(apiresponse["apiReturn"] == "Fail")
          {
            this.medHistoryaddbool = true;
            generateAlertMessage(this.dialog, 'Medical history added failed.');           
          }
          else if(apiresponse["apiReturn"] == "Invalid Auth Key")
          {                  
            this.thisDialogRef.close('Confirm');   
            AuthFailedMessage(this.dialog,this.router);  
            return;       
          }  
          this.thisDialogRef.close('Confirm');       
          });

          
      }

      else if(this.updateflag == 1)
      {
        
        let residentmedhistory: UpdateResidentMedHistory = {
          siteId:this.SiteId,
          authKey: localStorage.getItem("Authkey"),
          notes : residentFormValue.notes.replace(/\s+/g, ' ').trim(),    
          allergies:residentFormValue.allergies.replace(/\s+/g, ' ').trim(),
          emergContactName:residentFormValue.emrcontactname.replace(/\s+/g, ' ').trim(),
          emergContactNo:residentFormValue.emrcontactnumber.toString(),
          emergContactEmail:residentFormValue.emrcontactemail.toString(),
          emrReportStatus:empotemr,
          medHistoryId:parseInt(this.medhistoryid),
          residentId:parseInt(this.medhistoryResidentid),
                
        }          
          this.residentService.updateMedicalHistory(residentmedhistory).pipe(takeUntil(this._onDestroy))
          .subscribe((apiresponse : ResidentForCreationResponse[])=>{            
          if(apiresponse["apiReturn"] == "Success")
          { 	
            this.medHistoryaddbool = false; 
            generateAlertMessage(this.dialog, 'Medical history edited successfully.');
          }    
          else if(apiresponse["apiReturn"] == "Fail")
          {
            this.medHistoryaddbool = true;
            generateAlertMessage(this.dialog, 'Medical history edited failed.');            
          } 
          else if(apiresponse["apiReturn"] == "Invalid Auth Key")
          {                  
            this.thisDialogRef.close('Confirm');   
            AuthFailedMessage(this.dialog,this.router);  
            return;       
          }  
          this.thisDialogRef.close('Confirm');      
          });
      
          
      }
    }
    catch (err) {
      throw new Error('medical-history.component.ts' + ' - updateMedicalHistory() - ' + err.message);
    }

 } 

 changebuttonvalue(event)
 {    
   try
   {  
      if(!SessionCheck(this.router))
      {
        this.thisDialogRef.close('Cancel');
          return;
      }
      if(event.target.textContent != "Add File")
      {          
          this.clkaddbutton = 1;   
          this.medsavebutton = true; 
          this.medEMRfilesave = true;          
          this.medproceduredate = "";
          this.medsource = "";          
          document.getElementById("clkfileupload").click();
      }
      else
      {                     
        if(this.medEMRfilesave == true)
        {          
            var todaydate = new Date();
            var proceduredate = new Date(this.medproceduredate); 
            let formattedDt = moment(proceduredate).format('MM/DD/YYYY');
            var statedate = moment(this.startDate).format('MM/DD/YYYY');
            var _statedate = new Date(statedate)            
            if(proceduredate < _statedate)
            {              
                document.getElementById("Prodatepicker").focus();  
                generateAlertMessage(this.dialog, "Procedure date should be more than or equal to '01/01/1900'.");       
                return;
            }                                    
            var getmedprocedureDate = this.getErrorMessage(this.medproceduredate)                                                     
            if(this.medproceduredate == "")  
            {
                document.getElementById("Prodatepicker").focus();  
                generateAlertMessage(this.dialog, "Please enter the procedure date.");       
                return;
            }
            else if(getmedprocedureDate != undefined)
            {
                generateAlertMessage(this.dialog, getmedprocedureDate);
                return;
            }
            else if(this.medproceduredate != "" && proceduredate > todaydate)
            {                         
                document.getElementById("Prodatepicker").focus();                 
                generateAlertMessage(this.dialog, "Procedure date should be less than or equal to Today date"); 
                return;                            
            }
            else if(this.medsource == "")
            {              
                document.getElementById("myInput").focus(); 
                generateAlertMessage(this.dialog, "Please enter the source.");                        
                return;
            }
            else
            {                         
                  this.medEMRfilesave = false;      
                  var filename = this.addEMRFileName.split(".");
                  let addemrreport : ShowEMRFileReport ={
                  siteId: this.SiteId, 
                  authKey: localStorage.getItem("Authkey"),  
                  residentId : parseInt(this.medhistoryResidentid),
                  fileName :  filename[0].toString(),
                  procedureDate : formattedDt,
                  source : this.medsource,
                  uploadDate : this.meddate.toString()
                }   
                              
                this.residentService.addEMRReport(addemrreport).pipe(takeUntil(this._onDestroy))
                .subscribe((apiresponse : ResidentForCreationResponse[])=>{                      
                if(apiresponse.toString() == "true")
                { 
                  this.checkemrflag = 1;
                  this.medsavebutton = false;              
                  this.clkaddbutton = 0;
                  this.uploademrfilevalue = 0;
                  this.medEMRfilename = "";
                  this.addEMRFileName = "";
                  this.btnvalue="Choose File";             
                  this.getEMRReport(this.medhistoryResidentid);
                } 
                else if(apiresponse["condition"] == "Authfalse")
                {    
                    this.thisDialogRef.close('close');              
                    AuthFailedMessage(this.dialog,this.router);  
                    return;       
                }         
                else
                {
                  this.medEMRfilesave = true;
                }
                });
            }
          }
        }
  }
  catch (err) {
    throw new Error('medical-history.component.ts' + ' - changebuttonvalue() - ' + err.message);
  }
  
 }

 getToday(): string {
  return new Date().toISOString().split('T')[0];
  }
 changeValue(clkevent,flag)
 {  
   if(flag == 0)
      this.medproceduredate = clkevent.targetElement.value;
   else 
   {
    this.medsource = clkevent.target.value; 
    this.medsource = this.medsource.trim();
    let element = document.getElementById('myInput');
    element.className = 'enable';
   }                    
 }

 setfocusforsource()
 {
    if(this.medproceduredate) 
    {
      document.getElementById("myInput").focus(); 
      let element = document.getElementById('myInput');
      element.className = 'enable';
    }   
         
 }

 
 addEMRReport(filename)
 {    
   try
   {    
      this.btnvalue = "Add File";
      this.medsavebutton = false;
      var getaddfiledata = [];
      this.meddate = new Date();  
      this.meddate = ('0' +(this.meddate.getMonth() + 1)).slice(-2) + "/" + ('0' + this.meddate.getDate()).slice(-2) + "/" + this.meddate.getFullYear().toString().substr(-2); 
      
      var getfilename = filename.split(".");
          
      let showEMRfilelist : ShowEMRFileReport ={
        siteId: this.SiteId, 
        authKey: localStorage.getItem("Authkey"),
        residentId : this.medhistoryResidentid,
        fileName :  getfilename[0],
        procedureDate : "",
        source : "",
        uploadDate : this.meddate
      }
      
      getaddfiledata.push(showEMRfilelist)      
      this.dataSource = getaddfiledata;    
  }
  catch (err) {
    throw new Error('medical-history.component.ts' + ' - addEMRReport() - ' + err.message);
  }

 }

 getEMRReport(residentId)
 {     
   try
   {
      this.medsavebutton = true;    
      let residentbyid: ResidentByID = {
        // siteId:this.SiteId, 
        authKey: localStorage.getItem("Authkey"),
        residentId : parseInt(residentId)
      }   
      this.residentService.getEMRReport(residentbyid).pipe(takeUntil(this._onDestroy))
      .subscribe((ResidentbyId : any[])=>{    
        this.Residentbyid = ResidentbyId;         
        this.dataSource_Exist = this.Residentbyid; 
        this.dataSource_ExistLength=this.dataSource_Exist.length;
      }); 
  }
  catch (err) {
    throw new Error('medical-history.component.ts' + ' - getEMRReport() - ' + err.message);
  }
 }

 deleteEMRFile(reportId,residentid,filename)
 {   
   try
   {
   
     
    if(!SessionCheck(this.router))
     {       
        return;
     }
      this.clkaddbutton = 1; 
      var ConfirmMessageData = {
        ConfirmMessage: "Are you sure you want to delete the report?"
      }
      let dialogRef = this.dialog.open(ConfirmMessageComponent, {
        disableClose: true,
        width: 'auto',
        height: 'auto',
        panelClass: 'myapp-no-padding-dialog',
        autoFocus: false,
        data: ConfirmMessageData
      });
     
      dialogRef.afterClosed().subscribe(result => {       
          if (result == "Yes") {             
            let fileName : ReportbyName = {
                siteId: this.SiteId, 
                authKey: localStorage.getItem("Authkey"),
                fileName : filename.toString()
            }              
            this.residentService.deleteEMRFile(fileName).pipe(takeUntil(this._onDestroy))
            .subscribe((apiresponse : ResidentForCreationResponse[])=>{   
              
            if(apiresponse.toString() == "true")
            {                 
                this.deleteEMRReport(reportId,residentid);            
            }   
            else if(apiresponse.toString()  == 'false')
            {
              generateAlertMessage(this.dialog, 'EMR file deleted failed.');   
            }                      
            else if(apiresponse["condition"] == "Authfalse")
            {   
                 this.thisDialogRef.close('close');               
                AuthFailedMessage(this.dialog,this.router);  
                return;       
            }  
              
          });
        }
        else
        {  
          this.clkaddbutton = 0;      
          return false;
        }
      });
        
  }
  catch (err) {
    throw new Error('medical-history.component.ts' + ' - deleteEMRFile() - ' + err.message);
  }
 }

 deleteEMRReport(reportId,residentid)
 {
   try
   {
    let reportbyid: ReportById = {
      siteId: this.SiteId, 
      authKey: localStorage.getItem("Authkey"),
      reportId :parseInt(reportId)
    }
    
    this.residentService.deleteEMRReport(reportbyid).pipe(takeUntil(this._onDestroy))
          .subscribe((apiresponse : ResidentForCreationResponse[])=>{          
          if(apiresponse.toString() == "true")
          {                  
            this.clkaddbutton = 0;  
            generateAlertMessage(this.dialog, 'EMR file deleted successfully.');                                            
            this.getEMRReport(residentid);          
          }
          else if(apiresponse.length == 0)
          {
            generateAlertMessage(this.dialog, 'EMR file deleted failed.');            
          } 
          else if(apiresponse["condition"] == "Authfalse")
          {   
              this.thisDialogRef.close('close');               
              AuthFailedMessage(this.dialog,this.router);  
              return;       
          }              
        }); 
    }
    catch (err) {
      throw new Error('medical-history.component.ts' + ' - deleteEMRReport() - ' + err.message);
    }   
 }
 

 onOpenEMRReport(fileName)
 {   
    window.open(appsettings.RESIDENT_MEDICALHISTORY + fileName + ".pdf","_blank");
 }

 getErrorMessage(pickerInput: string): string {   
   
  if (!moment(pickerInput).isValid()) {      
    return 'Please enter valid date format MM/DD/YYYY';
  }        
}  

ngOnDestroy() {
	this._onDestroy.next();
	this._onDestroy.complete();
}
}
